import { render, staticRenderFns } from "./cssTest.vue?vue&type=template&id=251f2b87&scoped=true"
import script from "./cssTest.vue?vue&type=script&lang=ts"
export * from "./cssTest.vue?vue&type=script&lang=ts"
import style1 from "./cssTest.vue?vue&type=style&index=1&id=251f2b87&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "251f2b87",
  null
  
)

export default component.exports